<app-header [deviceXs]="deviceXs"></app-header>
<app-content [deviceXs]="deviceXs"></app-content>
